"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryOperatorParameters = exports.QueryOperators = void 0;
const typegate_1 = require("typegate");
const dateTime_1 = require("./dateTime");
exports.QueryOperators = {
    sum: 'sum',
    subtract: 'subtract',
    multiply: 'multiply',
    subtractDates: 'subtractDates',
    formula: 'formula',
    countEqual: 'countEqual',
    fetch: 'fetch',
    fetchSpecificId: 'fetchSpecificId',
    shiftDateBackwards: 'shiftDateBackwards',
    shiftDateForwards: 'shiftDateForwards',
};
exports.queryOperatorParameters = typegate_1.t.object(typegate_1.t.optionalProperty('numeric', typegate_1.t.array(typegate_1.t.union(typegate_1.t.number, typegate_1.t.string))), typegate_1.t.optionalProperty('formula', typegate_1.t.string), typegate_1.t.optionalProperty('formulaParams', typegate_1.t.any), typegate_1.t.optionalProperty('dateUnit', typegate_1.t.enum(dateTime_1.DateUnits)), typegate_1.t.optionalProperty('controlValue', typegate_1.t.unknown), typegate_1.t.optionalProperty('fetch', typegate_1.t.object(typegate_1.t.property('firstNonEmptyValueAt', typegate_1.t.array(typegate_1.t.string)))), typegate_1.t.optionalProperty('fetchSpecificId', typegate_1.t.object(typegate_1.t.property('specificValueAt', typegate_1.t.string), typegate_1.t.property('matchValue', typegate_1.t.string))), typegate_1.t.optionalProperty('shiftDateParams', typegate_1.t.object(typegate_1.t.property('dateFormat', typegate_1.t.string), typegate_1.t.property('timeRoundingType', dateTime_1.timeRoudingType), typegate_1.t.property('shiftValue', typegate_1.t.number), typegate_1.t.optionalProperty('shiftMagnitude', typegate_1.t.enum(dateTime_1.ShiftMagnitudes)))));
var QueryOperatorNames;
(function (QueryOperatorNames) {
    QueryOperatorNames["sum"] = "sum";
    QueryOperatorNames["subtract"] = "subtract";
    QueryOperatorNames["multiply"] = "multiply";
    QueryOperatorNames["subtractDates"] = "subtractDates";
    QueryOperatorNames["formula"] = "formula";
    QueryOperatorNames["countEqual"] = "countEqual";
    QueryOperatorNames["fetch"] = "fetch";
    QueryOperatorNames["fetchSpecificId"] = "fetchSpecificId";
    QueryOperatorNames["shiftDateBackwards"] = "shiftDateBackwards";
    QueryOperatorNames["shiftDateForwards"] = "shiftDateForwards";
})(QueryOperatorNames || (QueryOperatorNames = {}));
